import { render } from "./UboCompany.vue?vue&type=template&id=535a62e8&scoped=true"
import script from "./UboCompany.vue?vue&type=script&lang=js"
export * from "./UboCompany.vue?vue&type=script&lang=js"

import "./custom-ubo.scss?vue&type=style&index=0&id=535a62e8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535a62e8"]])

export default __exports__